<template>
  <b-row>
    <b-col cols="12">
      <form-wizard-view />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormWizardView from './FormWizardView.vue'

export default {
  components: {
    BRow,
    BCol,
    FormWizardView,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
